import { Box, Grid, Stack, Typography } from "@mui/material"
import { FC } from "react"
import BoxCard from "./BoxCard"
import { getFormattedCardNumber, getRandomArbitrary } from "../../../../../lib/general"
import Link from "next/link"
import Pages from "src/constants/pages"

interface AnalyticBoxProps {
  title: string
  credit: number | string
  userCardNumber: string
  creditLayerId: number
}

const colors = ["#05334d", "#5fba8e", "#0a2654", "#bf63bb", "#573955", "#198a79"]

const CreditLayerBox: FC<AnalyticBoxProps> = props => {
  const { title, credit, userCardNumber, creditLayerId } = props
  return (
    <BoxCard sx={{ backgroundColor: colors[getRandomArbitrary(0, colors.length - 1)], height: 120 }}>
      <Grid container p={2}>
        <Grid item md={12}>
          <Stack color='grey.100' spacing={1}>
            <Box>
              <Link href={Pages.Facilities}>
                <Typography variant='subtitle1'>{title}</Typography>
              </Link>
            </Box>
            <Box>
              <Typography variant='body1'>{getFormattedCardNumber(userCardNumber)}</Typography>
            </Box>
            <Box display='flex' alignItems='center' pt={1} gap={0.5}>
              <Typography variant='h5'>{credit?.toLocaleString()}</Typography>
              <Typography variant='subtitle2'>ریال</Typography>
            </Box>
          </Stack>
        </Grid>
      </Grid>
    </BoxCard>
  )
}

export default CreditLayerBox
